import * as go from 'gojs';
import noop from 'lodash/noop';
import { toggleTextOnTextEditing } from '../../../../../utils/toggle-text-on-text-editing';
import { registerNodeTemplate } from '../../common/utils/registerNodeTemplate';
import { stickyNodeTemplate } from '../sticky-node';
import { TEXT_COLOR_PROP } from './../../common/config/common-prop-names';

export const setupStickyNode = (diagram: go.Diagram, categoryName: string) => {
  registerNodeTemplate(diagram, categoryName, stickyNodeTemplate());
  toggleTextOnTextEditing(diagram, categoryName, TEXT_COLOR_PROP);
  return noop;
};
